import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { CompareResults } from "../../../queries/useBuildComparison";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { gridCellClass } from "./TireComparisonGrid";

type ProductInfoProps = {
  part: TirePartItem;
};

export const hasOtherInfo = (visibleResults?: CompareResults[]): boolean => {
  const result =
    visibleResults?.some(
      ({ part }) => part.partDetails.primaryPart.tireOriginalEquipmentFlag
    ) ?? false;
  return result;
};

export const OtherInformtation: FunctionComponent<ProductInfoProps> = ({
  part,
}) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(gridCellClass, "text-xs")}>
      {part.partDetails.primaryPart.tireOriginalEquipmentFlag
        ? t("compare.originalEquipment")
        : t("compare.notAvailable")}
    </div>
  );
};
